/**
 * Títulos editoriales de las misiones. quests.csv no aporta nombres oficiales:
 * estos títulos solo orientan al jugador. Las misiones sin título aquí (7, 8, 9)
 * no se publican en las guías hasta confirmar su funcionamiento.
 */
export const questTitles: Record<number, string> = {
  0: 'Sebina, primera parte',
  1: 'Sebina, segunda parte',
  2: 'Marlon, primera parte',
  3: 'Marlon, parte adicional del BK',
  4: 'Devin, materiales',
  5: 'Devin, Barracks',
  6: 'Devin, Refuge',
}

export const publishedQuestIds = Object.keys(questTitles).map(Number)

/** Valores de referencia comunicados por el staff, para contrastar en el panel técnico. */
export const questExpectations: Record<number, { levelMin: number; zen: number }> = {
  0: { levelMin: 150, zen: 10000 },
  1: { levelMin: 150, zen: 20000 },
  2: { levelMin: 220, zen: 30000 },
  3: { levelMin: 220, zen: 20000 },
  4: { levelMin: 380, zen: 50000 },
  5: { levelMin: 400, zen: 70000 },
  6: { levelMin: 400, zen: 100000 },
}

export const questTitle = (id: number) => questTitles[id] ?? `Misión ${id}`
